import Vue from "vue";
import VueRouter from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import AddMoment from "@/components/AddMoment";
import Account from "@/components/Account";
// import About from '@/components/About';

Vue.use(VueRouter);
if (!window.VueRouter) Vue.use(VueRouter);
export default new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "HelloWorld",
      component: HelloWorld
    },
    {
      path: "/add-moment",
      name: "AddMoment",
      component: AddMoment,
      meta: ["modal"]
    },
    {
      path: "/edit-moment/:momentId",
      name: "EditMoment",
      component: AddMoment,
      meta: ["modal"]
    },
    {
      path: "/export",
      name: "Export",
      component: () => import(/* webpackChunkName: "export" */ "@/components/Export"),
      meta: ["modal"]
    },
    {
      path: "/recommend",
      name: "Recommend",
      component: () => import(/* webpackChunkName: "recommend" */ "@/components/Recommend")
    },
    {
      path: "/feedback",
      name: "Feedback",
      component: () => import(/* webpackChunkName: "recommend" */ "@/components/FeedBack")
    },
    {
      path: "/account",
      name: "Account",
      component: Account
    },
    {
      path: "/invite",
      name: "Invite",
      component: () => import(/* webpackChunkName: "invite" */ "@/components/Invite")
    }
  ]
});
